// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { Icon } from '../../../components/common/index';
import theme from '../../../theme-config';

export default class PortaOutPage extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <View style={styles.container}>
        <Icon name="roundcheckbox" size={40} color={theme.gray.normal} />
        <Text style={styles.text}>{this.props.text}</Text>
      </View>
    );
  }
}

type Props = {
  text: string,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 20,
    },
    text: {
      marginTop: 20,
      textAlign: 'center',
      fontSize: 20,
      color: theme.gray.normal,
    },
  });
